import fr from 'facet-rest';

const calendarEventFieldsToHide = [
  'createdAt',
  'updatedAt',
  'householdId',
  'eventId',
  'startTime',
  'endTime',
  'location',
  'meetingType',
  'eventType',
  'subject',
  'lastName',
  'priority',
  'bestNextStepId',
  'content',
  'bufferLength',
  'isCancelled',
  'title',
  'description',
  'source',
];

// eslint-disable-next-line import/prefer-default-export
export const ClientSchedulerMeetingBooked = fr.metaOverride()
  .nameOverride(calendarEventFieldsToHide, { hidden: true })
  .nameOverride('attendees', { readonly: true });
